import React from "react";

const clock = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="50 50 530 530"
  >
    {/* <!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--> */}
    <path
      d="
        M320 64
        C461.4 64 576 178.6 576 320
        C576 461.4 461.4 576 320 576
        C178.6 576 64 461.4 64 320
        C64 178.6 178.6 64 320 64
        z
        M296 184L296 320C296 328 300 335.5 306.7 340
        L402.7 404C413.7 411.4 428.6 408.4 436 397.3
        C443.4 386.2 440.4 371.4 429.3 364
        L344 307.2L344 184C344 170.7 333.3 160 320 160
        C306.7 160 296 170.7 296 184
        z
      "
      fill={props.color}
    />
  </svg>
);

export default clock;